import React, { useState, useEffect, useCallback, useRef  } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import config from "../../../../aws-exports";
import {
  Visibility,
  Share,
  AttachFile,
  Refresh,
  Delete,
} from "@mui/icons-material";
import { useLoading } from "../../../../context/LoadingContext";
import { getParameterFromManager } from "../../../../services/Utils";
import {
  fetchData,
  postQuery,
  uploadVideoToS3,
  searchfetchQueries,
} from "../../../Requirement/services/RequirementServices";
import { v4 as uuidv4 } from "uuid";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import dayjs from "dayjs";

const AllProcurementDocuments = ({ tabFilter, categories, allProjectList,activeUser }) => {
  console.log("page categories@@", categories);
  console.log("page allProjectList@@", allProjectList);
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [documents, setDocuments] = useState([]);
  const [allSellerList, setAllSellerList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentName, setDocumentName] = useState("");
  const [category, setCategory] = useState("");
  const [project, setProject] = useState("");
  const [seller, setSeller] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [errors, setErrors] = useState({
    file: "",
    documentName: "",
    category: "",
    project: "",
    seller: "",
    expiryDate: "",
  });
  const [searchInputType, setSearchInputType] = useState("text");
  const [searchProject, setSearchProject] = useState("");

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  // Load sellers
  const loadSellers = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listAMTPLUsersAdm",
          option: "seller",
          rowStart: 0,
          pageSize: 1,
          filterTerms: {
            // UserType: "seller",
          },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allPartners] = await Promise.all([
          searchfetchQueries({
            target: "listAMTPLUsersAdm",
            option: "seller",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: {
              // UserType: "seller",
            },
          }),
        ]);

        setAllSellerList(allPartners);
      } else {
        setAllSellerList([]);
      }
    } catch (error) {
      console.error("Error loading sellers: ", error);
      setAllSellerList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  console.log("tabFilter@@", tabFilter);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilter = (event) => {
    const value = event.target.value;
    setFilter(value);
    setSearchTerm(""); // Reset search term when filter changes
    // Set input type based on filter
    if (value === "searchDateUploaded" || value === "searchExpiryDate") {
      setSearchInputType("date");
    } else {
      setSearchInputType("text");
    }
  };

  const handleOpenModal = () => {
    if (categories.length === 0 || allProjectList.length === 0) {
      setModal({
        show: true,
        type: "warning",
        title: "Cannot Upload Document",
        message:
          "Please ensure that document types and projects are available before uploading a document.",
        autoClose: false,
      });
      return;
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedFile(null);
    setDocumentName("");
    setCategory("");
    setProject("");
    setSeller("");
    setExpiryDate("");
    setErrors({
      file: "",
      documentName: "",
      category: "",
      project: "",
      expiryDate: "",
    });

    
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (!file) {
      setErrors((prev) => ({ ...prev, file: "Please select a file." }));
    } else if (
      !["application/pdf", "image/jpeg", "image/png"].includes(file.type)
    ) {
      setErrors((prev) => ({
        ...prev,
        file: "Only PDF, JPEG, or PNG files are allowed.",
      }));
    } else if (file.size > 5 * 1024 * 1024) {
      setErrors((prev) => ({
        ...prev,
        file: "File size must be less than 5MB.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, file: "" }));
    }
  };

  const handleDocumentNameChange = (event) => {
    const value = event.target.value;
    setDocumentName(value);
    setErrors((prev) => ({ ...prev, documentName: "" }));
  };

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setCategory(value);
    if (!value) {
      setErrors((prev) => ({ ...prev, category: "Please select a category." }));
    } else {
      setErrors((prev) => ({ ...prev, category: "" }));
    }
  };

  const handleProjectChange = (event) => {
    const value = event.target.value;
    setProject(value);
    if (!value) {
      setErrors((prev) => ({ ...prev, project: "Please select a project." }));
    } else {
      setErrors((prev) => ({ ...prev, project: "" }));
    }
  };
  const handleSellerChange = (event) => {
    const value = event.target.value;
    setSeller(value);
    if (!value) {
      setErrors((prev) => ({ ...prev, seller: "Please select a seller." }));
    } else {
      setErrors((prev) => ({ ...prev, seller: "" }));
    }
  };

  const handleExpiryDateChange = (event) => {
    const value = event.target.value;
    setExpiryDate(value);
    if (value) {
      const selectedDate = new Date(value);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Reset time for comparison
      if (selectedDate < currentDate) {
        setErrors((prev) => ({
          ...prev,
          expiryDate: "Expiry date cannot be earlier than today.",
        }));
      } else {
        setErrors((prev) => ({ ...prev, expiryDate: "" }));
      }
    } else {
      setErrors((prev) => ({ ...prev, expiryDate: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {
      file: "",
      documentName: "",
      category: "",
      project: "",
      expiryDate: "",
    };
    let isValid = true;

    if (!selectedFile) {
      newErrors.file = "Please select a file.";
      isValid = false;
    } else if (
      !["application/pdf", "image/jpeg", "image/png"].includes(
        selectedFile.type
      )
    ) {
      newErrors.file = "Only PDF, JPEG, or PNG files are allowed.";
      isValid = false;
    } else if (selectedFile.size > 5 * 1024 * 1024) {
      newErrors.file = "File size must be less than 5MB.";
      isValid = false;
    }

    if (!category) {
      newErrors.category = "Please select a category.";
      isValid = false;
    }
    if (!project) {
      newErrors.project = "Please select a project.";
      isValid = false;
    }
    if (!seller) {
      newErrors.seller = "Please select a seller.";
      isValid = false;
    }

    if (expiryDate) {
      const selectedDate = new Date(expiryDate);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Reset time for comparison
      if (selectedDate < currentDate) {
        newErrors.expiryDate = "Expiry date cannot be earlier than today.";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleProjectFilter = (event) => {
    const value = event.target.value;
    setSearchProject(value); // Update searchProject state
  };

  const handleUpload = async () => {
    if (validateForm()) {
      try {
        setLoading(true);
        let fileRef = "";
        let fileRefUrl = "";
        if (selectedFile instanceof File) {
          console.log("Uploading file:", selectedFile);
          console.log(
            "DocumentType:",
            category,
            "ProjectID:",
            project,
            "Expire",
            expiryDate,
            "docname",
            documentName
          );
          // return;
          const result = await uploadVideoToS3(selectedFile);
          fileRef = result.fileName;
          fileRefUrl = result.url;
          console.log("File uploaded to S3:", { fileRef, fileRefUrl });

          let procurementDocumentsInput = {
            DocumentID: uuidv4(),
            DocumentName: documentName.trim() || null,
            DocumentFile: fileRef,
            ProjectID: project,
            SellerID: seller,
            DocumentType: category,
            CreatedBy: activeUser,
            ExpiryDate: expiryDate || null,
          };

          if (!expiryDate) {
            procurementDocumentsInput = {
              DocumentID: uuidv4(),
              DocumentName: documentName.trim() || null,
              DocumentFile: fileRef,
              ProjectID: project,
              SellerID: seller,
              DocumentType: category,
              CreatedBy: activeUser,
            };
          }
          const body = {
            target: "createProcurementDocuments",
            procurementDocumentsInput,
          };

          const result1 = await postQuery(body);
          if (!result1 || !result1.items) {
            throw new Error(`Failed to create user document.`);
          }
          console.log("Document saved successfully:", result1);
        }
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: `Procurement Document uploaded successfully.`,
          autoClose: false,
          nextAction: () => {
            handleCloseModal();
            setTimeout(() => {
              fetchDocuments();
            }, 100);
          },
        });
      } catch (error) {
        console.error("Error uploading file to S3 or saving document:", error);
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message:
            error.message ||
            `Failed to upload file or save document. Please try again.`,
          autoClose: false,
        });
      } finally {
        setLoading(false);
        handleCloseModal();
      }
    }
  };

  const handleVisibilityClick = (doc) => {
    if (doc.documentpath && doc.document) {
      const fullPath = `${doc.documentpath}${doc.document}`;
      console.log(`Opening document at: ${fullPath}`);
      window.open(fullPath, "_blank");
    } else {
      console.error(`Document path or file is missing for document ${doc.id}`);
      setErrors((prev) => ({
        ...prev,
        file: "Unable to open document. File path is missing.",
      }));
    }
  };

  const handleShareClick = (docId) => {
    console.log(`Share clicked for document ${docId}`);
  };

  const handleAttachClick = (docId) => {
    console.log(`Attach clicked for document ${docId}`);
  };

  const handleRefreshClick = (docId) => {
    console.log(`Refresh clicked for document ${docId}`);
  };

  const handleDeleteClick = (docId) => {
    console.log(`Delete clicked for document ${docId}`);
  };

  const handleTagClick = (tag, docId) => {
    console.log(`Tag "${tag}" clicked for document ${docId}`);
    setFilter(tag);
  };

  const fetchDocuments = async (tabFilter) => {
    try {
      setLoading(true);
      const bucket = process.env.REACT_APP_AMTPL_BUCKET;
      const filePath = `public/media/amtpl/`;
      const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

      // Build filterTerms based on filter and searchTerm
      const filterTerms = {};
      if (tabFilter !== "All Documents") {
        filterTerms.DocumentType = tabFilter;
      }
      if (searchTerm) {
        if (filter === "searchDateUploaded" && searchInputType === "date") {
          // Format date to match backend (assuming ISO format or DD MMM YYYY)
          filterTerms.CreatedAtLT =
            "'" + dayjs(searchTerm).format("YYYY-MM-DD").toString() + "'";
        } else if (
          filter === "searchExpiryDate" &&
          searchInputType === "date"
        ) {
          filterTerms.ExpiryDateLT =
            "'" + dayjs(searchTerm).format("YYYY-MM-DD").toString() + "'";
        } else {
          // Default to document name search
          filterTerms.DocumentName = searchTerm;
        }
      }
      if (searchProject) {
        filterTerms.ProjectID = searchProject; // Add project filter
      }
      console.log("filterTerms@@", filterTerms);

      let response = null;

      if (searchInputType === "date" && Object.keys(filterTerms).length > 0) {
        response = await fetchData({
          target: "listProcurementDocuments",
          userOrder: "DocumentID",
          rowStart: 0,
          pageSize: 1000,
          filterTerms,
        });
      } else {
        response = await fetchData({
          target: "listProcurementDocuments",
          userOrder: "DocumentID",
          rowStart: 0,
          pageSize: 1000,
          // filterTerms,
          DocumentName: searchTerm,
          DocumentType: tabFilter,
          ProjectID: searchProject,
        });
      }
      const formattedDocuments = response.items.map((doc) => ({
        id: doc.DocumentId,
        type: doc.DocumentName || doc.DocumentType,
        documentpath: fileUrl,
        document: doc.DocumentFile || "",
        added: doc.CreatedAt
          ? dayjs(doc.CreatedAt).format("DD MMM YYYY")
          : "N/A",
        expires: doc.ExpireAt
          ? dayjs(doc.ExpireAt).format("DD MMM YYYY")
          : "N/A",
      }));
      setDocuments(formattedDocuments || []);
    } catch (error) {
      console.error("Error fetching documents:", error);
      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  // Get current date in YYYY-MM-DD format for min attribute
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    console.log("filter!!!!", filter);
    console.log("searchTerm!!!!", searchTerm);
    console.log("tabFilter!!!!", tabFilter);
    console.log("searchProject!!!!", searchProject);
    loadSellers();
    fetchDocuments(tabFilter);
  }, [searchTerm, filter, tabFilter, searchProject.loadSellers]); // Added filter to dependencies

  useEffect(() => {
      const handleClickOutside = (event) => {
        if (isModalOpen && modalRef.current && !modalRef.current.contains(event.target)) {
          handleCloseModal();
        }
      };
  
      if (isModalOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isModalOpen, handleCloseModal]);

  return (
    <div className="kyc-document-container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="header-doc">
        {searchInputType === "text" ? (
          <input
            type="text"
            placeholder="Search documents..."
            value={searchTerm}
            onChange={handleSearch}
            className="search-bar"
          />
        ) : (
          <input
            type="date"
            value={searchTerm}
            onChange={handleSearch}
            className="search-bar"
            placeholder="Select date"
          />
        )}
        <select
          value={filter}
          onChange={handleFilter}
          className="filter-dropdown"
        >
          <option value="">Filter by...</option>
          <option value="searchDocumentName">Document Name</option>
          <option value="searchDateUploaded">Date Uploaded</option>
          <option value="searchExpiryDate">Expiry Date</option>
        </select>
        <select
          value={searchProject}
          onChange={handleProjectFilter}
          className="filter-dropdown"
        >
          <option value="">Filter by Project..</option>
          {allProjectList.map((proj, index) => (
            <option key={index} value={proj.ProjectID}>
              {proj.ProjectName}
            </option>
          ))}
        </select>
        <button
          className="submit-btn-more"
          onClick={handleOpenModal}
          
        >
          + Upload Document
        </button>
      </div>
      <div className="documents-grid">
        {documents.map((doc) => (
          <div key={doc.id} className="document-card">
            <div
              className="document-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span className="document-icon">
                📄 <span className="document-type">{doc.type}</span>
              </span>
              <Visibility
                style={{ cursor: "pointer" }}
                onClick={() => handleVisibilityClick(doc)}
                title="View Document"
              />
            </div>
            <div className="document-details">
              <p>
                <b>Type:</b> {doc.type}
              </p>
              <p>
                <b>Added:</b> {doc.added}
              </p>
              <p>
                <b>Expires:</b> {doc.expires}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Bootstrap Modal (Centered) */}
      <div
        className={`modal fade ${isModalOpen ? "show" : ""}`}
        id="uploadModal"
        tabIndex="-1"
        aria-labelledby="uploadModalLabel"
        aria-hidden={!isModalOpen}
        style={{ display: isModalOpen ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" ref={modalRef}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="uploadModalLabel">
                Upload New Document
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div className="mb-3">
                <label htmlFor="documentNameInput" className="form-label">
                  Document Name: <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="documentNameInput"
                  value={documentName}
                  onChange={handleDocumentNameChange}
                  className="form-control"
                  placeholder="Enter document name"
                />
                {errors.documentName && (
                  <div className="text-danger mt-1">{errors.documentName}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="fileInput" className="form-label">
                  Select File: <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  id="fileInput"
                  onChange={handleFileChange}
                  className="form-control file-input"
                />
                <small className="form-text text-muted">
                  {selectedFile ? selectedFile.name : "No file chosen"}
                </small>
                {errors.file && (
                  <div className="text-danger mt-1">{errors.file}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="categorySelect" className="form-label">
                  Category: <span className="text-danger">*</span>
                </label>
                <select
                  id="categorySelect"
                  value={category}
                  onChange={handleCategoryChange}
                  className="form-select category-dropdown"
                >
                  <option value="">Select a category</option>
                  {categories.map((cat, index) => (
                    <option key={index} value={cat.Value}>
                      {cat.Value}
                    </option>
                  ))}
                </select>
                {errors.category && (
                  <div className="text-danger mt-1">{errors.category}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="projectSelect" className="form-label">
                  Project: <span className="text-danger">*</span>
                </label>
                <select
                  id="project"
                  value={project}
                  onChange={handleProjectChange}
                  className="form-select project-dropdown"
                >
                  <option value="">Select a project</option>
                  {allProjectList.map((proj, index) => (
                    <option key={index} value={proj.ProjectID}>
                      {proj.ProjectName}
                    </option>
                  ))}
                </select>
                {errors.project && (
                  <div className="text-danger mt-1">{errors.project}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="seller" className="form-label">
                  Seller: <span className="text-danger">*</span>
                </label>
                <select
                  id="seller"
                  value={seller}
                  onChange={handleSellerChange}
                  className="form-select seller-dropdown"
                >
                  <option value="">Select a seller</option>
                  {allSellerList.map((v, index) => (
                    <option key={index} value={v.AMTPLUserID}>
                      {v.FirstName} {v.LastName}
                    </option>
                  ))}
                </select>
                {errors.seller && (
                  <div className="text-danger mt-1">{errors.seller}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="expiryDateInput" className="form-label">
                  Expiry Date (Optional):
                </label>
                <input
                  type="date"
                  id="expiryDateInput"
                  value={expiryDate}
                  onChange={handleExpiryDateChange}
                  className="form-control"
                  min={today}
                />
                {errors.expiryDate && (
                  <div className="text-danger mt-1">{errors.expiryDate}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="submit-btn-more"
                onClick={handleUpload}
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default AllProcurementDocuments;
